<template>
    <div class="box-list">
        <summary-box color="#6c6c6c">
            <template v-slot:icon>
                <i class="fas summary-icon fa-user-hard-hat"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{ trans.attendanceSummaryList.total }}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $utils.formatNumber(summaryData.total) }}</span>
            </template>
        </summary-box>

        <summary-box color="#6c98ba">
            <template v-slot:icon>
                <i class="far summary-icon fa-business-time"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{ trans.attendanceSummaryList.present }}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $utils.formatNumber(summaryData.present) }}</span>
            </template>
        </summary-box>

        <summary-box color="#d76436">
            <template v-slot:icon>
                <i class="far summary-icon fa-stopwatch"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{ trans.attendanceSummaryList.late }}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $utils.formatNumber(summaryData.late) }}</span>
            </template>
        </summary-box>

        <summary-box color="#aa1a11">
            <template v-slot:icon>
                <i class="fas summary-icon fa-home-alt"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{ trans.attendanceSummaryList.absent }}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $utils.formatNumber(summaryData.absent) }}</span>
            </template>
        </summary-box>

        <summary-box color="#cca972">
            <template v-slot:icon>
                <i class="fas summary-icon fa-hard-hat"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{ trans.attendanceSummaryList.onsite }}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $utils.formatNumber(summaryData.onsite) }}</span>
            </template>
        </summary-box>

        <summary-box color="#a8a8a8">
            <template v-slot:icon>
                <i class="far summary-icon fa-door-open"></i>
            </template>

            <template v-slot:label>
                <span class="white--text">{{ trans.attendanceSummaryList.leave }}</span>
            </template>

            <template v-slot:count>
                <span class="white--text">{{ $utils.formatNumber(summaryData.leave) }}</span>
            </template>
        </summary-box>
    </div>
</template>

<script>
import SummaryBox from '@/components/SummaryBox'

export default {
    name: 'AttendanceSummaryList',

    components: { SummaryBox },

    data () {
        return {
            summaryData: {
                total: 0,
                present: 0,
                late: 0,
                absent: 0,
                onsite: 0,
                leave: 0
            }
        }
    },

    methods: {
        async getData () {
            const res = await this.axios.get('dashboard/attendance-summary')
            if (res && res.data && res.data.status) {
                this.summaryData = res.data.data
            }

            return this.summaryData
        }
    },

    created () {
        this.registerLang({
            attendanceSummaryList: ['total', 'present', 'late', 'absent', 'onsite', 'leave']
        })
    }
}
</script>

<style lang="scss" scoped>
.summary-icon {
    color: white;
    font-size: 24px;
    margin-left: 0.25rem;
}
.box-list {
    margin-top: 26px;
    margin-bottom: 30px;
    display: flex;

    & > *:not(:first-child) {
        margin-left: 22px;
    }

    & > * {
        margin-bottom: 30px;
    }

    .icon {
        width: 21px;
        height: 24px;
    }

    @media only screen and (max-width: 1350px) {
        & > *:not(:nth-child(3n+1)) {
            margin-left: 1rem;
        }
    }

    @media only screen and (max-width: 1308px) {
        overflow-x: auto;

        & > *:not(:nth-child(3n+1)) {
            margin-left: 1%
        }
    }
}
@media only screen and (max-width: 1440px) {
    .box-list {
        justify-content: space-around;
        margin-bottom: 0px;
        flex-wrap: wrap;

        & > *:not(:nth-child(3n+1)) {
            margin-left: 22px;
        }

        & > *:nth-child(3n+1) {
            margin-left: 0px;
        }
    }
}
</style>
